import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper w-full <sm:50px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_advantages_advantage_card = _resolveComponent("the-advantages-advantage-card")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_accent_button = _resolveComponent("accent-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_swiper, {
      slidesPerView: _ctx.amountOfSlides,
      loopedSlides: 6,
      centeredSlides: true,
      loop: true,
      initialSlide: 0,
      spaceBetween: _ctx.spaceBetweenSlides,
      freeMode: true,
      speed: 5000,
      autoplay: {
        delay: 500,
        disableOnInteraction: true,
      },
      class: "h-160px <sm:h-120px cursor-move"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_swiper_slide, null, {
          default: _withCtx(() => [
            _createVNode(_component_the_advantages_advantage_card, {
              removed: "",
              title: "Бюрократия"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("быстрая и простая отправка заявки в любой из банков, на любой из продуктов")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.shortened)
          ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_the_advantages_advantage_card, { title: "Удобство" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("личный кабинет прост и удобен, оперативная передача информации и отслеживание статуса")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.shortened)
          ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_the_advantages_advantage_card, { title: "Надежность" }, {
                  default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createTextVNode("мы являемся официальными партнерами банков и имеем соотвествующие ")),
                    _createVNode(_component_router_link, { to: "/certificates" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_accent_button, { class: "<sm:text-14px" }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createTextVNode("сертификаты")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_swiper_slide, null, {
          default: _withCtx(() => [
            _createVNode(_component_the_advantages_advantage_card, { title: "лучшая поддержка" }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("персональный менеджер за каждым агентом, оперативный ответ на вопрос")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.shortened)
          ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_the_advantages_advantage_card, { title: "высокий доход" }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("нет ограничений по выплатам и уровню заработка, бонусы и поощрения")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["slidesPerView", "spaceBetween"])
  ]))
}